<template>
  <el-container>
    <el-aside :width="isCollapse ? '70px' : '200px'">
      <el-scrollbar>
        <el-row>
          <el-col :span="24">
            <el-image
              @click="open('default')"
              class="leftLog"
              :class="{ leftLoginIcon: isCollapse }"
              fit="fill"
              :src="logo"
            ></el-image>
            <!-- :src="require('@/assets/image/logo.png')" -->

            <el-menu
              active-color="#ff4848"
              background-color="#001529"
              class="el-menu-vertical-demo"
              text-color="#fff"
              :collapse="isCollapse"
              :default-active="activeMenu"
              router
            >
            <!-- :default-active="router.currentRoute.value.fullPath" -->
              <!-- <MenuList :menuList="menuData"></MenuList> -->

              <template v-for="subitem in menuData" :key="subitem.path">
                <template v-if="subitem.nav == 3">
                  <el-menu-item
                    :style="isCollapse ? 'width:70px' : 'width:200px'"
                    @click="open(subitem.ename)"
                    :index="'/' + subitem.path"
                  >
                    <el-icon class="iconcolor">
                      <component :is="subitem.icon"></component>
                    </el-icon>
                    <template #title
                      ><span @click="open(subitem.ename)">{{
                        subitem.name
                      }}</span></template
                    >
                  </el-menu-item>
                </template>

                <template v-else-if="subitem.nav == 1">
                  <el-sub-menu
                    :style="isCollapse ? 'width:70px' : 'width:auto'"
                    :index="'/' + subitem.path"
                  >
                    <template #title>
                      <el-icon class="iconcolor">
                        <component :is="subitem.icon"></component>
                      </el-icon>
                      <span>{{ subitem.name }}</span>
                    </template>

                    <template v-for="item in subitem.children" :key="item.path">
                      <el-menu-item
                        v-if="item.nav == 1"
                        class="el-menu-item-h"
                        :style="isCollapse ? 'width:200px' : 'width:188px'"
                        :index="'/' + item.path"
                        @click="open(item.ename)"
                      >
                        <template #title>
                          <el-icon class="iconcolor1">
                            <component :is="item.icon"></component>
                          </el-icon>
                          <span>{{ item.name }}</span>
                        </template>
                      </el-menu-item>
                      <el-sub-menu v-if="item.nav == 3" :index="'/' + item.path" class="submenuchild">
                        <template #title>
                          <el-icon class="iconcolor1">
                            <component :is="item.icon"></component>
                          </el-icon>
                          <span style="color:#666">{{ item.name }}</span>
                        </template>
                        <template
                          v-for="item1 in item.children"
                          :key="item1.path"
                        >
                          <el-menu-item
                            v-if="item1.nav == 1"
                            class="el-menu-item-hh"
                            @click="open(item1.ename)"
                            :index="'/' + item1.path"
                          >
                            <el-icon class="iconcolor1">
                              <component :is="item1.icon"></component>
                            </el-icon>
                            <template #title
                              ><span @click="open(item1.ename)">{{
                                item1.name
                              }}</span></template
                            >
                          </el-menu-item>
                        </template>
                      </el-sub-menu>
                    </template>
                  </el-sub-menu>
                </template>
              </template>
            </el-menu>
            
          </el-col>
        </el-row>
      </el-scrollbar>
    </el-aside>
    <el-container>
      <el-header class="headertop" style="padding-left: 10px">
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content bg-purple" style="padding: 10px 0px">
              <el-icon
                style="vertical-align: -10px; color: #424f63"
                :size="20"
                @click="doCollapse"
                ><Fold
              /></el-icon></div
          ></el-col>
          <el-col :span="12" style="text-align: right">
            <div
              class="grid-content bg-purple-light"
              style="padding-top: 4px; padding: 10px 0px"
            >
              <el-dropdown>
                <span class="el-dropdown-link">
                  <el-avatar
                    style="vertical-align: -6px; margin-right: 10px"
                    size="small"
                    :src="require('@/assets/image/avatar.png')"
                  />{{ $store.state.user.nickname }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="open('password')">修改密码</el-dropdown-item>
                    <el-dropdown-item @click="doLogout">退出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div></el-col
          >
        </el-row>
      </el-header>
      <!--进行路由跳转-->
      <el-main class="mainBox">
        <router-view />
      </el-main>
      <el-footer class="mainFooter">2026 © by 神兽档案局服务平台 · <a href="https://www.zhidieyun.com" target="_blank" style="color:#666;text-decoration: none;">翌羽信息科技(上海)有限公司</a> 版权所有</el-footer>
    </el-container>
  </el-container>
</template>

<script setup>
// 组合式api
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import storage from "@/util/storage";

import { getUserMenu } from "@/api/user";

// import MenuList from "@/components/common/MenuList";

let store = useStore();
const router = useRouter();

const menuData = ref();

const isCollapse = ref(false);
const logo = ref(require('@/assets/image/logo-left.png'));


let doCollapse = () => {
  isCollapse.value = !isCollapse.value;
  logo.value = isCollapse.value? require('@/assets/image/logo-left.png'):require('@/assets/image/logo-left.png')
};

onMounted(() => {
  //修复刷新加载不了问题
  if (store.getters.menus.length <= 0) {
    getUserMenu().then((res) => {
      menuData.value = res.data.extend.permissions;
      routerPackag(res.data.extend.permissions);
    });
  } else {
    menuData.value = store.getters.menus;
    routerPackag(store.getters.menus);
  }
  //console.log('router',router.currentRoute.value);
  //console.log('router',storage.getSessionObject("currentRoute"));
  // console.log("menuData.value-----", menuData.value);

  let currentRouteName = storage.getSessionObject("currentRoute");
  // console.log("---currentRouteName", currentRouteName);
  if (currentRouteName && router.hasRoute(currentRouteName)) {
    router.push({ name: currentRouteName });
  } else {
    router.push({ name: "default" });
  }
});

let doLogout = function () {
  store.dispatch("LOGOUT").then(() => {
    router.push({ name: "login" });
  });
};

let open = function (name) {
  storage.saveSessionObject("currentRoute", name);
  router.push({ name });
};
const routerPackag = (routers) => {
  if (store.getters.menuRouteLoaded) {
    // console.log("动态路由已加载");
    return;
  }

  routers.filter((itemRouter) => {
    if (
      itemRouter.component != "main" &&
      itemRouter.path != "" &&
      itemRouter.path != null
    ) {
      router.addRoute("main", {
        path: `/${itemRouter.path}`,
        name: itemRouter.ename,
        // component: () => import(`@/${itemRouter.component}`)
        component: () => import(`@/components/${itemRouter.component}`),
      });
    }
    // 是否存在子集
    if (itemRouter.children && itemRouter.children.length) {
      routerPackag(itemRouter.children);
    }
    return true;
  });
};

//适时监控路由
const activeMenu = ref(router.path);
watch(()=> router.currentRoute.value.path,
(toPath) => {
  if (toPath.includes('shenshou')) {
    activeMenu.value = '/shenshou/index'
  } else if (toPath.includes('exampaper')) {
    activeMenu.value = '/exampaper/index'
  } else if (toPath.includes('wxuser')) {
    activeMenu.value = '/wxuser/index'
  } else {
    activeMenu.value = toPath
  }

},{immediate:true, deep:true})

</script>
<style scoped>
body {
  background-color: #f4f4ff;
}
.submenuchild {
  margin-left:-8px
}
.el-menu--popup-right-start .submenuchild {
  margin-left:0;
}
.el-menu--popup-right-start .el-menu-item-h {
  display: flex;
}
.el-menu-item-h {
  display: inline-block;
  /* min-width: 60px; */
}
.el-menu--vertical:not(.el-menu--collapse):not(.el-menu--popup-container) .el-menu-item {
  padding-left: 32px;
}

.el-menu--vertical:not(.el-menu--collapse):not(.el-menu--popup-container) .el-menu-item-hh {
  padding-left: 60px;
    padding-right: 0;
}

.leftLog {
  width: 60px;
  margin: 10px auto;
  display: block;
  padding: 10px 15px;
  border-radius: 10px;
  cursor: pointer;
}
.leftLoginIcon {
  width: 40px;
  /* height: 35px; */
  /* padding: 8px; */
}

.el-container {
  height: 100%;
}

.el-footer {
  line-height: 60px;
}

.el-aside {
  background-color: #001529;
  color: var(--el-text-color-primary);
  /* text-align: center; */
  /* line-height: 200px; */
}
.el-menu {
  border-right: transparent;
}
.el-menu-item.is-active {
  color: #fff;
  background: #1890ff;
}
.el-menu-item:hover {
  background: #1890ff;
}

.el-main {
  color: var(--el-text-color-primary);
}
.el-dropdown-link {
  cursor: pointer;
  /* color: var(--el-color-primary); */
  display: flex;
  align-items: center;
}
</style>